module.exports = __webpack_public_path__ + "static/media/cacceso2.8da882c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flat/cacceso2.svg
// module id = 380
// module chunks = 0